export default __webpack_public_path__ + "static/media/portada-inicio.30d11eb2.jpg";